import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=3a512438&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=3a512438&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a512438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a512438')) {
      api.createRecord('3a512438', component.options)
    } else {
      api.reload('3a512438', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=3a512438&scoped=true", function () {
      api.rerender('3a512438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Menu/Menu.vue"
export default component.exports